module.exports = __webpack_public_path__ + "img/31.efbba8a5.svg";